import { Component, HostBinding } from '@angular/core';
import { ContentBlockViewComponent } from '@tytapp/content/content-block-view-component';
import { HeroBlock } from './hero-block';
import { ContentModule } from '@tytapp/content';


@Component({
    standalone: true,
    selector: 'tyt-hero-block',
    imports: [ ContentModule ],
    template: `
        <div class="image-box">
          <div class="hero-image" [responsiveBackgroundImage]="block.image">
            <div class="overlay"></div>
          </div>
          @if ((block.layout ?? 'standard') === 'standard') {
            <h1 *ngIf="block.heading" [class.overlay]="block.overlayHeading">{{ block.heading }}</h1>
          }
        </div>

        @if ((block.layout ?? 'standard') === 'standard') {
            <div class="text cms-content" *ngIf="block.text"
                [innerHTML]="block.text | markdownToHtml | trustHtml">
            </div>
        }

        @if (block.layout === 'aside') {
            <div class="content-box">
                @if (block.heading) {
                    <h1 [class.overlay]="block.overlayHeading">{{ block.heading }}</h1>
                }
                @if (block.text) {
                    <div class="text cms-content"
                    [innerHTML]="block.text | markdownToHtml | trustHtml"></div>
                }
            </div>
        }
        `,
    styles: [`
        :host {
            background-color: #21232a;
            color: white;
            display: block;
            margin-bottom: 1em;
        }

        :host-context(.cms-page:first-child > tyt-content-view > .single-column > tyt-content-block:first-child) :host {
            margin-top: -4.1em;
        }

        :host.aside {
            display: flex;
            flex-direction: row;
            align-items: flex-start;

            .image-box {
                display: flex;
                align-items: center;
                justify-content: center;
                width: 300px;
                flex-shrink: 0;

                .hero-image {
                    width: 100%;
                }
            }

            .content-box {
                display: flex;
                flex-direction: column;
                flex-grow: 1;
                position: relative;

                h1 {
                    text-align: left;
                    margin-top: 0;
                }

                .text {
                    text-align: left;
                }
            }

            @media (max-width: 899px) {
                flex-direction: column;
                .image-box {
                    width: 100%;
                }
            }
        }

        .text {
            padding: 32px;
            font-size: 120%;
        }

        ::ng-deep .text p:last-child {
            margin-bottom: 0;
        }

        .hero-image {
            aspect-ratio: 16/9;
            background-size: cover;
            background-position: center;
            background-repeat: no-repeat;
            position: relative; // for overlay
        }

        :host.fade-bottom {
            background-color: transparent;
            .hero-image .overlay {
                position: absolute;
                inset: 0;
                background: linear-gradient(0deg, #101217 5%, transparent 90%);
            }
        }

        :host.fullbleed:not(.aside) {
            background-color: transparent;
            .hero-image {
                margin: 0 calc(-50vw + 50%);
                width: 100vw;
                aspect-ratio: 30/9;
                .overlay {
                    inset: 0 calc(-50vw + 50%);
                    width: 100vw;
                    aspect-ratio: 30/9;
                }
            }
        }

        .image-box {
            position: relative;
        }

        h1 {
            padding: 0 32px;
            font-size: 32pt;
            font-weight: bold;

            @media (max-width: 599px) {
                font-size: 22pt;
            }
        }

        :host:not(.aside) {
            h1.overlay {
                position: absolute;
                bottom: 0.5em;
                width: 100%;
                text-shadow: 0px 2px 8px black;
            }
        }

        :host[data-alignment="center"] {
            h1 {
                text-align: center;
            }

            .text {
                text-align: center;
            }
        }

        :host[data-alignment="right"] {
            h1 {
                text-align: right;
            }

            .text {
                text-align: right;
            }
        }
    `]
})
export class ViewComponent extends ContentBlockViewComponent<HeroBlock> {
    @HostBinding('attr.data-alignment') get alignment() { return this.block.alignment; }
    @HostBinding('class.fullbleed') get fullbleed() { return this.block.fullbleed; }
    @HostBinding('class.fade-bottom') get fade() { return this.block.fadeBottom; }
    @HostBinding('class.aside') get isAsideLayout() { return this.block.layout === 'aside'; }
}
